import template from './template.html'
import Controller from './controller'

export default {
  restrict: 'E',
  template,
  replace: true,
  controllerAs: 'vm',
  controller: Controller,
  bindings: {
    urlBeingEdited: '=',
    linkEditing: '=',
    linkElementBeingEdited: '<',
    hidePopover: '&',
    onUrlChanged: '&',
    updateLink: '&',
  },
}
